import styled from 'styled-components'

const HR = styled.hr`
  margin-top: 10px;
  margin-bottom: 10px;
  @media(max-width: 767px) {
    display: none;
  }
`

export default HR
